import { render, staticRenderFns } from "./more-info.vue?vue&type=template&id=fe3238c4&scoped=true&lang=pug&"
import script from "./more-info.vue?vue&type=script&lang=js&"
export * from "./more-info.vue?vue&type=script&lang=js&"
import style0 from "./more-info.vue?vue&type=style&index=0&id=fe3238c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3238c4",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/moreInformation?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230928165100%2Fcomponents%2Fproducts%2Fmore-info.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports